/* eslint-disable react/style-prop-object */
/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import useDragDetection from 'hooks/useDragDetection';
import BannerControlsPage from './Banner/BannerControlsPage';

const ImgStyle = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  maxHeight: '297px',
  objectFit: 'contain',
  backdropFilter: 'blur(30px)',
  [theme.breakpoints.down('md')]: {
    maxHeight: '205px',
  },
  [theme.breakpoints.down('sm')]: {
    maxHeight: '75px',
  },
}));

const BoxStyle = styled(Box)(({ theme }) => ({
  width: '100%',
  maxHeight: '297px',
  cursor: 'pointer',
  background: 'center / auto no-repeat',
  [theme.breakpoints.up('lg')]: {
    minHeight: '200px',
  },
  [theme.breakpoints.up('md')]: {
    minHeight: '180px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '60px',
    maxHeight: '75px',
    backgroundPosition: 'top left',
  },
}));

function CarouselItem({ item }) {
  const { file, link } = item;

  const { handleMouseDown, dragging } = useDragDetection();

  const handleOpen = (e) => {
    if (!dragging) {
      if (link) window.open(link);
    }
  };

  return (
    <BoxStyle
      onClick={handleOpen}
      sx={{
        backgroundImage: `url(${file})`,
      }}
      onMouseDownCapture={handleMouseDown}
    >
      <ImgStyle src={file} alt="" />
    </BoxStyle>
  );
}

export default function Banner() {
  const { info } = useSelector((state) => state.main);

  const carouselRef = useRef();

  const settings = {
    dots: true,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    ...BannerControlsPage({
      sx: { mt: 3 },
    }),
  };

  // const handlePrevious = () => {
  //   carouselRef.current.slickPrev();
  // };

  // const handleNext = () => {
  //   carouselRef.current.slickNext();
  // };

  return (
    <Box sx={{ marginBottom: '48px' }}>
      {info.file_list ? (
        <Slider ref={carouselRef} {...settings}>
          {(info?.file_list || []).map((item) =>
            item.type === 'BANNER' ? (
              <CarouselItem key={item.id} item={item} />
            ) : null
          )}
        </Slider>
      ) : (
        <Skeleton
          animation="wave"
          height={297}
          width="100%"
          style={{ transform: 'none' }}
        />
      )}
    </Box>
  );
}
